import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import TermsAndPolicies from "@/pages/TermsAndPolicies";
import LegalConsent from "@/pages/LegalConsent";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import SharePage from "@/pages/SharePage";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider } from "@/lib/auth";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/terms-and-policies" element={<TermsAndPolicies />} />
            <Route path="/legal/consent" element={<LegalConsent />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
